var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid-content"},[_c('div',{staticClass:"grid-banner-image",style:({ backgroundImage: `url(${_vm.gridBannerImageSrc})` })}),_c('div',{staticClass:"grid-overlay-image"},[_c('h1',{staticClass:"grid-banner-title"},[_vm._v(_vm._s(_vm.gridBannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }